import get from 'lodash/get';
import orderBy from 'lodash/orderBy';
import { LocationState } from '../States';
import { LocationTypes } from '../Types';
import { updateState } from '../Store';

export default function(state = LocationState, action) {
  switch (action.type) {
    case LocationTypes.SET_ERROR:
      return { ...state, error: get(action, 'payload.error') };
    case LocationTypes.IS_API_PROGRESS:
      return {
        ...state,
        isAPIProgress: action.payload,
      };
    case LocationTypes.ON_SUCCESS_HOME_CITY_FETCH:
      return updateState(state, { homeCities: orderBy(action.payload || [], ['name'], ['asc']) });
    case LocationTypes.ON_SUCCESS_JOB_CITY_FETCH:
      return updateState(state, { jobCities: orderBy(action.payload || [], ['name'], ['asc']) });
    case LocationTypes.ON_SUCCESS_CITY_SEARCH:
      return updateState(state, {
        searchedCities: orderBy(action.payload || [], ['name'], ['asc']),
      });
    case LocationTypes.ON_SUCCESS_LOCALITY_FETCH:
      return updateState(state, {
        localities: orderBy(action.payload || [], ['name'], ['asc']),
      });
    default:
      return state;
  }
}
